import jsPDF from "jspdf";
import logo from "./OptiMed_Renewal_Logo.png";
import { AgeBand, GroupRenewal, GroupRenewalIPO, ProductType, RateType, RenewalType, Tier } from "./types";

const fourTierList = [Tier.Employee, Tier.EmployeeSpouse, Tier.EmployeeChild, Tier.Family];
const threeTierList = [Tier.Employee, Tier.EmployeePlusOne, Tier.Family];
const twoTierList = [Tier.Employee, Tier.Family];

function textFromRenewalType(renewal: GroupRenewal, renewalDate: Date) {
  const formattedRenewalDate = renewalDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const productTypes = [...renewal.type].join(" and ");
  if (renewal.renewalType === RenewalType.RateChange) {
    return (
      `${formattedRenewalDate} is the anniversary of ${renewal.name}'s OptiMed ${productTypes} ` +
      `group insurance plan. During your annual review we determined your plan will require a  ` +
      `rate change to service your ${productTypes} plan upon renewal. Starting on ${formattedRenewalDate} ` +
      `your ${productTypes} group costs will be changed to the costs listed below. We thank you for ` +
      `your business and look forward to serving you again this upcoming plan year.`
    );
  } else if (renewal.renewalType === RenewalType.NewCarrier) {
    return (
      `${formattedRenewalDate} is the anniversary of ${renewal.name}'s ` +
      `OptiMed ${productTypes} group insurance plan. We are able to obtain the most competitive ` +
      `renewal premiums through an alternative insurance underwriter, allowing us to ` +
      `provide your company with a ${productTypes} plan with the most competitive rates. ` +
      `We thank you for your business and look forward to serving ` +
      `you again this upcoming plan year.`
    );
  } else if (renewal.renewalType === RenewalType.NoChange) {
    return (
      `${formattedRenewalDate} is the anniversary of ${renewal.name}'s ` +
      `OptiMed group insurance plan. We are pleased to inform you that your ${productTypes} premium ` +
      `renewal amount will remain unchanged.`
    );
  }
  // else if (renewal.renewalType === RenewalType.DualCarrier) {
  // }
}

function readDateFromISOString(str: string) {
  const [year, month, day] = str.split("T")[0].split("-").map(Number);
  console.log(year, month, day);
  return new Date(year, month - 1, day);
}

function addIPOTable(doc: jsPDF, ipos: GroupRenewalIPO[], yStartCoordinate: number) {
  let currentY = yStartCoordinate;
  const ROW_HEIGHT = 5;

  console.log(ipos);
  if (ipos.some((ipo) => ipo.rateType === RateType.AgeBanded)) {
    const ageBandedHeadersFormatted = {
      [AgeBand.UnderForty]: "Under 40",
      [AgeBand.FortyToFortyNine]: "40-49",
      [AgeBand.OverFifty]: "50+",
    };
    const tierCount = ipos[0].tiers.length;

    if (tierCount === 12) {
      var tierList = fourTierList;
    } else if (tierCount === 9) {
      var tierList = threeTierList;
    } else if (tierCount === 6) {
      var tierList = twoTierList;
    } else {
      throw "There was not a valid tier count on the first IPO";
    }
    const columnWidth = 15;
    const padding = 0;
    const x = 20;

    const fontName = doc.getFont().fontName;

    const headers = ipos.map((ipo) => ipo.name);
    const tableCellWidth = (doc.internal.pageSize.getWidth() - 40) / ipos.length;
    const colX = (i) => (i === 0 ? x : x + i * columnWidth + padding + 15);

    headers.forEach((h, i) => {
      doc.text(h, colX(i * 3 + 1), currentY);
    });

    currentY += ROW_HEIGHT;

    const ageBandedHeaders = [AgeBand.UnderForty, AgeBand.FortyToFortyNine, AgeBand.OverFifty];

    ipos.forEach((ipo, i) => {
      ageBandedHeaders.forEach((h, j) => {
        doc.text(ageBandedHeadersFormatted[h], colX(i * 3 + j + 1), currentY);
      });
    });

    currentY += ROW_HEIGHT;

    tierList.forEach((tier, r) => {
      doc.text(tier, colX(0), currentY);

      ipos.forEach((ipo, c) => {
        ageBandedHeaders.forEach((header, i) => {
          doc.text(
            `$${parseFloat(ipo.tiers.find((ipoTier) => ipoTier.tier === tier && ipoTier.ageBand === header).price.toString()).toFixed(2)}`,
            colX(c * 3 + i + 1),
            currentY
          );
        });
      });

      currentY += ROW_HEIGHT;
    });

    return currentY;
  } else {
    const tierCount = ipos[0].tiers.length;

    if (tierCount === 4) {
      var tierList = fourTierList;
    } else if (tierCount === 3) {
      var tierList = threeTierList;
    } else if (tierCount === 2) {
      var tierList = twoTierList;
    } else {
      throw "There was not a valid tier count on the first IPO";
    }
    const columnWidth = 35;
    const padding = 0;
    const x = 20;

    const fontName = doc.getFont().fontName;

    const headers = ipos.map((ipo) => ipo.name);
    const tableCellWidth = (doc.internal.pageSize.getWidth() - 40) / ipos.length;
    const colX = (i) => x + i * columnWidth + padding;

    headers.forEach((h, i) => {
      console.log(h, colX(i + 1), currentY);
      doc.text(h, colX(i + 1), currentY);
    });

    currentY += ROW_HEIGHT;

    tierList.forEach((tier, r) => {
      doc.text(tier, colX(0), currentY);

      ipos.forEach((ipo, c) =>
        doc.text(
          `$${parseFloat(ipo.tiers.find((ipoTier) => ipoTier.tier === tier).price.toString()).toFixed(2)}`,
          colX(c + 1),
          currentY
        )
      );

      currentY += ROW_HEIGHT;
    });

    return currentY;
  }
}

export async function generateIncreaseLetterPDF(renewal: GroupRenewal): Promise<jsPDF> {
  const doc = new jsPDF();

  doc.setFontSize(8);

  const pageWidth = doc.internal.pageSize.getWidth();

  console.log(pageWidth);

  let currentY = 20;

  const renewalDate = readDateFromISOString(renewal.renewalDate);

  const blob = await (await fetch(logo)).blob(); // fetch does the actual retrieval
  const dataUrl: string = await new Promise((res) => {
    // FileReader just re-encodes
    const r = new FileReader();
    r.onload = () => res(r.result as string);
    r.readAsDataURL(blob);
  });

  function fitWithin(w: number, h: number, maxW: number, maxH: number) {
    const scale = Math.min(maxW / w, maxH / h);
    return { width: w * scale, height: h * scale };
  }

  const imageProps = doc.getImageProperties(dataUrl);
  const { width, height } = fitWithin(imageProps.width, imageProps.height, 60, 20);
  doc.addImage(dataUrl, "PNG", 30, currentY, width, height);

  currentY += height + 5;

  doc.text(
    new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    30,
    currentY
  );
  currentY += 5;

  doc.text(renewal.name, 30, currentY);
  currentY += 5;
  doc.text(renewal.address1, 30, currentY);
  currentY += 5;
  doc.text(`${renewal.city}, ${renewal.state} ${renewal.zip}`, 30, currentY);
  currentY += 5;
  doc.text("Attn: Benefit Plan Administrator", 30, currentY);
  currentY += 10;

  doc.text(`Re: Group # ${renewal.groupId}`, 20, currentY);
  currentY += 5;
  doc.text("Dear Benefit Plan Administrator,", 20, currentY);
  currentY += 5;

  let line = doc.splitTextToSize(textFromRenewalType(renewal, renewalDate), pageWidth - 40);
  doc.text(line, 20, currentY);
  currentY += 5 + (line.length * doc.getLineHeight()) / doc.internal.scaleFactor;

  if (renewal.renewalType === RenewalType.NoChange) {
    doc.text("CURRENT MONTHLY COST*", pageWidth / 2, currentY, { align: "center" });
    currentY += 5;
    currentY = addIPOTable(doc, renewal.currentIpos, currentY);
  } else {
    doc.text("CURRENT MONTHLY COST*", pageWidth / 2, currentY, { align: "center" });
    currentY += 5;
    currentY = addIPOTable(
      doc,
      renewal.currentIpos.map((ipo) => ipo.previousYearIPO),
      currentY
    );

    doc.text("RENEWAL MONTHLY COST*", pageWidth / 2, currentY, { align: "center" });
    currentY += 5;
    currentY = addIPOTable(doc, renewal.currentIpos, currentY);
  }

  doc.text("* Includes insurance premium and non-insurance service fees", 20, currentY);
  currentY += 10;

  // doc.text(
  //   "Upon acceptance of your renewal costs above, please sign and return this document to " +
  //     "am@optimedhealth.com prior to your renewal effective date. If this renewal letter is " +
  //     "not signed and returned your plan benefits may expire and coverage may not be renewed.",
  //   20,
  //   currentY,
  //   { maxWidth: pageWidth - 40 }
  // );
  // currentY += 15;

  // doc.text("Cost Acceptance Signature", 20, currentY);
  // currentY += 20;
  doc.text(
    "If you would like to review your cost increase, discuss plan utilization, or have us " +
      "provide alternate plan options in order to lower your renewal increase, please contact your " +
      "broker, or us at 800-836-6036. We look forward to working with you on ways to continuously " +
      "improve our health plan's value to you and your employees. Thank you for being a group policyholder.",
    20,
    currentY,
    { maxWidth: pageWidth - 40 }
  );

  return doc;
}
